import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { CustomReportResponse } from './useCreateCustomReportMutation';
import { customReportKeys } from './customReportKeys';
import { CustomReportsParams } from './useCustomReportsQuery';
import { useTranslation } from 'react-i18next';

const duplicateCustomReport = async (
  id: string
): Promise<CustomReportResponse> => {
  const response = await EXPRESS_API.post(`/custom-reports/${id}/duplicate`);
  return response.data;
};

export const useDuplicateCustomReportMutation = (
  params: CustomReportsParams
) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation(duplicateCustomReport, {
    onSuccess: () => {
      successToast({ title: t('Custom report duplicated successfully') });
      queryClient.invalidateQueries(customReportKeys.custom_reports(params));
    },
    onError: () => {
      errorToast({ title: t('Something went wrong duplicating the report') });
    },
  });
};
